import { TranslateService } from './../../shared/translate/translate.service';
import { AuthService } from './../../shared/models/auth.service';
import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { InstanceModel } from '../models/instance.model';
import { InstanceService } from '../models/instance.service';
import { Observable } from 'rxjs/Observable';
import { Router, ActivatedRoute } from '@angular/router';
import { WeGoConfig, IAPIResponse, ApplicationRouteURL,WeGoAuthorizedLink, DataListModel,Permission, PermissionType, RoleLevel, IKeyValueInterface } from '../../shared/config';
import { CloneEntityModel } from '../models/cloneentity.model';

@Component({
  selector: 'wego-instance',
  template: require('../views/instance-list.component.html'),
  providers: [InstanceService],
  styles: [
    `.modelCloneCustomClass {
        width:85%;
      }
      .modelResultCustomClass {
        
      }
      .cloneResultTableRow{
        text-align: left;
      }
      .cloneResultDivClass{
        width: 100%;
        overflow:auto;
        max-height: 274px;
        margin-top:  15px;
      }
    `
  ]
})
export class InstanceListComponent implements OnInit {
  urlInstanceAdd: string;
  DataListModel: DataListModel;
  instanceList: InstanceModel[];
  public cloneEntityModel: CloneEntityModel;
  cloneEntityList: CloneEntityModel[];
  errorModel: IKeyValueInterface[];
  instanceHashId: string;
  isWegoAdmin : boolean=false;
  message: string;
  apiErrorMsg: string;
  //apiCloneErrorMsg: string='';
  isCloneError: boolean = false;
  isLoading: boolean;
  urlInstanceUpdate: string;
  urlDefaultPage: string;
  urlInstanceAdminList:string;
  deleteMessage: string;
  instanceModel: InstanceModel;
  customerHashID: string = "";
  private popupMsg: string;
  private module: string;
  private breadCrumbList: string;
  addInstanceLink: WeGoAuthorizedLink;
  cloneNewInstanceName: string = '';
  roleLevel = RoleLevel;
  cloneExistingInstanceHashId: string = '';
  cloneResult: boolean = false;

  @ViewChild('confirmModal') public confirmModal: any;
  @ViewChild('successPopup') public successPopup: any;
  @ViewChild('cloneModel') public cloneModel: any;

  constructor(private instanceService: InstanceService,
    private translate: TranslateService,
    private authService: AuthService,
    private router: Router,
    private activeRoute: ActivatedRoute) {
  }

  ngOnInit() {
    this.instanceModel = new InstanceModel();
    this.urlInstanceAdd = this.authService.GetURL(ApplicationRouteURL.URL_INSTANCE_ADD);
    this.cloneEntityModel = new CloneEntityModel();
    this.module = this.translate.instant('LblInstance');
    this.DataListModel = this.authService.RetriveFilter(this.constructor.name);
    if(this.authService.GetHighestRoleLevel() <= this.roleLevel.Customer){
      this.DataListModel.searchField = ["instanceName", "currencySymbol", "currencyAbbreviation", "description", "customerName"];
    }
    else{
      this.DataListModel.searchField = ["instanceName", "currencySymbol", "currencyAbbreviation", "description"];
    }
    
    this.urlDefaultPage = this.authService.GetURL(ApplicationRouteURL.URL_DEFAULT_PAGE);
    this.urlInstanceUpdate = this.authService.GetURL(ApplicationRouteURL.URL_INSTANCE_UPDATE);
    this.urlInstanceAdminList =  this.authService.GetURL(ApplicationRouteURL.URL_ADMIN_OF_INSTANCE_LIST);

    this.activeRoute
      .params
      .subscribe(params => {
        let customerHashID = params['customerHashId'] || '';
        if (customerHashID != '') {
          this.customerHashID = customerHashID;
        }
        else {
          this.customerHashID = "";
        }
        this.GetInstanceList();
      });
    this.breadCrumbList = this.translate.instant('LblListPage', [this.module]);
    this.addInstanceLink = new WeGoAuthorizedLink(this.urlInstanceAdd, 
      Permission.PR_INSTANCE, PermissionType.INSERT,'btn btn-highlight navbar-right', 'LblAddNew');
  }

  public GetInstanceList() {
    this.isLoading = true;
    this.instanceService.GetInstanceList(this.DataListModel, this.customerHashID)
      .subscribe(
      (res: any) => {
        this.instanceList = res.data;
          this.isWegoAdmin = this.instanceList.length > 0 ? this.instanceList[0].isWegoAdmin : false;
        this.DataListModel.totalItems = res.totalRecords;
        this.DataListModel.infoMessage = res.error;
        this.isLoading = false;
      },
      (error: any) => {
        this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
      });
  }

  public OnPagingChange(event: any) {
    this.DataListModel.currentPage = 1;
    this.DataListModel.totalItems = 0;
    this.DataListModel.itemsPerPage = event.itemPerPage;
    this.GetInstanceList();
  }

  public OnSort(sortName: string) {
    this.DataListModel.sortType = sortName;
    this.DataListModel.sortReverse = !this.DataListModel.sortReverse;
    this.GetInstanceList();
  }

  public OnSearch(event: any) {
    this.DataListModel = this.authService.GetSearchParameters(this.DataListModel, event.searchTerm, event.isReset);
    this.GetInstanceList();
  }

  public OnPageChanged(event: any): void {
    this.DataListModel.currentPage = event.page;
    this.GetInstanceList();
  };

  public OnExport(event: any) {
    this.isLoading = true;
    this.instanceService.ExportInstanceList(this.DataListModel, this.customerHashID)
      .subscribe(
      (res: any) => {
        if (res && res._body) {
          let fileName = "Instance" + new Date().toISOString() + ".csv";
          this.authService.DownloadFile(fileName, res._body);
        }
        this.isLoading = false;
      },
      (error: any) => {
        this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
      });
  }
  public DeleteInstance() {
    this.isLoading = true;
    this.instanceService.DeleteInstance(this.instanceHashId)
      .subscribe(
      (res: any) => {
        if (res.data) {
          this.DataListModel.currentPage = 1;
          this.GetInstanceList();
          this.popupMsg = this.translate.instant('LblRecordRemovedSuccess', [this.module]);
          this.ShowSuccessPopup();
        }
        else {
          this.popupMsg = this.translate.instant('LblInstanceDeleteValidation');
          this.isLoading = false;
          this.ShowSuccessPopup();
        }
      },
      (error: any) => {
        this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
      });
    //);
  }

  public onSubmitClone() {
    this.isLoading = true;
    this.isCloneError = false;
    let formData = this.cloneEntityModel;
    this.instanceService.CloneInstance(formData).subscribe(
      res => {
        if (res.data) {
          this.cloneResult = true;
          this.cloneEntityList = res.data;
          this.isLoading = false;
        } else {
          this.isLoading = false;
          if (res.error == null) this.isCloneError = true;
          this.errorModel = res.error;
        }
      },
      error => {
        //this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
        this.isCloneError = true;
        this.isLoading = false;
      }
    );
  }

  public cloneSuccessClick() {
    this.cloneModel.hide();
    this.GetInstanceList();
  }

  public ConfirmSuccessClick(): void {
    this.confirmModal.hide();
    this.DeleteInstance();
  }

  public ShowConfirmModal(instanceHashId: string): void {
    this.isLoading = false;
    this.deleteMessage = this.translate.instant('LblRecordDeleteConfirmation', [this.module]);
    this.confirmModal.show();
    this.instanceHashId = instanceHashId;

  }
  public HideConfirmModal(): void {
    this.confirmModal.hide();
  }

  public ShowSuccessPopup(): void {
    this.successPopup.show();
  }

  public HideSuccessPopup(): void {
    this.successPopup.hide();
  }

  public ConfirmSuccessPopup(): void {
    this.successPopup.hide();
  }

  public ShowCloneModal(cloneInstanceHashId: string): void {
    this.errorModel = [];
    this.cloneEntityModel.newInstanceName = '';
    this.cloneResult = false;
    this.isCloneError = false;
    this.cloneEntityModel.exstingInstanceHashId = cloneInstanceHashId;
    this.cloneModel.show();
  }

  public HideCloneModal(): void {
    this.cloneEntityModel.newInstanceName = '';
    this.cloneModel.hide();
  }

  ngOnDestroy() {
    this.authService.SetFilter(this.constructor.name, this.DataListModel);
  }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/instance/components/instance-list.component.ts